export { useTranslation, I18nextTrans } from './useTranslation';

export type { T } from './useTranslation';
